import { SEGMENTS } from '../../data/conjointData';
import { InfoButton } from '../common/Tooltip';

export function MarketAtAGlance() {
  const priceSensitive = SEGMENTS[0];
  const lowInterest = SEGMENTS[1];
  const budgetSeekers = SEGMENTS[2];

  const statements = [
    {
      segment: priceSensitive.name,
      pct: priceSensitive.percentage,
      color: priceSensitive.color,
      text: <><span className="font-mono font-semibold">{(priceSensitive.percentage * 100).toFixed(1)}%</span> of the market is price-sensitive but stays interested up to <span className="font-mono">$1,499</span></>,
    },
    {
      segment: budgetSeekers.name,
      pct: budgetSeekers.percentage,
      color: budgetSeekers.color,
      text: <><span className="font-mono font-semibold">{(budgetSeekers.percentage * 100).toFixed(0)}%</span> are budget seekers who drop off sharply above <span className="font-mono">$499</span></>,
    },
    {
      segment: lowInterest.name,
      pct: lowInterest.percentage,
      color: lowInterest.color,
      text: <><span className="font-mono font-semibold">{(lowInterest.percentage * 100).toFixed(1)}%</span> won&apos;t buy at any configuration — don&apos;t chase them</>,
    },
  ];

  return (
    <div className="card card-accent-blue mb-6">
      <div className="flex items-center gap-2 mb-4">
        <h3 className="text-heading font-semibold text-secondary uppercase tracking-wider">Market at a Glance</h3>
        <InfoButton helpKey="marketAtAGlance" size={13} />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Segment statements */}
        <div className="lg:col-span-2 space-y-4">
          {statements.map(s => (
            <div key={s.segment} className="flex items-start gap-3">
              <div className="w-3 h-3 rounded-full shrink-0 mt-1.5" style={{ backgroundColor: s.color }} />
              <p className="text-sm md:text-base text-primary leading-relaxed">{s.text}</p>
            </div>
          ))}
          <p className="text-xs text-muted mt-2 pt-2 border-t border-border">
            Three distinct segments identified via k-means clustering on conjoint part-worth utilities. Source: CBC Study, n=<span className="font-mono">1,001</span>.
          </p>
        </div>

        {/* Mini segment bar chart */}
        <div className="flex flex-col justify-center gap-3">
          {statements.map(s => (
            <div key={s.segment}>
              <div className="flex items-center justify-between text-xs text-secondary mb-1">
                <span>{s.segment}</span>
                <span className="font-mono">{(s.pct * 100).toFixed(1)}%</span>
              </div>
              <div className="h-5 rounded-full overflow-hidden" style={{ backgroundColor: 'var(--color-surface)' }}>
                <div
                  className="h-full rounded-full transition-all"
                  style={{ width: `${s.pct * 100}%`, backgroundColor: s.color, opacity: 0.8 }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
